/** Bounded editor console diagnostics shared with project agents. */
export const CONSOLE_PROBLEM_LIMIT = 100;
export const CONSOLE_MESSAGE_LIMIT = 4000;
export interface ConsoleProblem {
  readonly level: 'warn' | 'error';
  readonly source: string;
  readonly message: string;
  readonly time: number;
  readonly count: number;
}
export interface ConsoleSnapshot {
  readonly entries: readonly ConsoleProblem[];
  /** Older problems excluded by the snapshot limit. */
  readonly omitted: number;
}
